import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
   padding: 80px 20px;
  background: #282c34;
  min-height: 60vh;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 40px;
  font-size: 2.2rem;
  color: #f5f5f5;

`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9; /* Ensures consistent shape across screen sizes */
  overflow: hidden;
`;
const ProjectCard = styled.div`
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 8px 20px rgba(0,0,0,0.15);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const Img = styled.img`
  width: 100%;
  height: 180px;
  object-fit: contain;
  border-radius: 10px;
  background: #111;
`;

const Name = styled.h3`
  color: #fff;
  margin: 12px 0 5px;
`;

const Issuer = styled.p`
  color: #aaa;
  font-size: 0.9rem;
`;
const CertiImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const Certifications = () => {
  const [certs, setCerts] = useState([]);

  useEffect(() => {
  fetch("https://portfoliodata7007.netlify.app/certification.json")
    .then(res => res.json())
    .then(data => setCerts(data))
    .catch(err => console.error("JSON Load Error:", err));
}, []);


  if (certs.length === 0) return null;
console.log(certs)
  return (
    <Container id="certifications">
      <Title>My Certifications</Title>
      <Grid>
        {certs.map((c, i) => (
          <ProjectCard key={i}>
            <ImageContainer>
              <CertiImage src={c.imageUrl} alt={c.title} />
            </ImageContainer>
            <Name>{c.title}</Name>
            <Issuer>{c.issuer}</Issuer>
          </ProjectCard>
        ))}
      </Grid>
    </Container>
  );
};

export default Certifications;
